export class AsyncState {
  public busy: boolean = false;
  public message: string = '';
  public success: boolean = false;
  public requestId: number = 0;
}
